import BezierEasing from 'bezier-easing';

/** Shared motion curves. Pattern durations and travel distances remain independent. */
export const MOTION_EASING = {
  settle: 'cubic-bezier(0.1, 0.9, 0.2, 1)',
  accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
  stateChange: 'cubic-bezier(0.2, 0, 0, 1)',
} as const;

/** Candidate companion to dialog rise: deliberate reveal, quicker retreat. */
export const STACK_REVEAL_MOTION = {
  expand: { duration: 300, easing: MOTION_EASING.settle },
  collapse: { duration: 180, easing: MOTION_EASING.accelerate },
} as const;

/** Push-aside for a docked stack: one unhurried glide both ways, so stowing never reads as a dismissal. */
export const STACK_STOW_MOTION = {
  duration: 420,
  fade: 320,
  easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
} as const;

const easingCache = new Map<string, (t: number) => number>();
/** A CSS `cubic-bezier()` curve as a function, for react-spring, which takes easing functions. Linear otherwise. */
export const cssEasingToFunction = (css: string): ((t: number) => number) => {
  const cached = easingCache.get(css);
  if (cached) return cached;
  const points = css
    .match(/cubic-bezier\(([^)]+)\)/)?.[1]
    .split(',')
    .map(Number);
  const easing = points?.length === 4 ? BezierEasing(points[0], points[1], points[2], points[3]) : (t: number) => t;
  easingCache.set(css, easing);
  return easing;
};
